import { render, staticRenderFns } from "./salesdata.vue?vue&type=template&id=b58eaf82&scoped=true"
import script from "./salesdata.vue?vue&type=script&lang=js"
export * from "./salesdata.vue?vue&type=script&lang=js"
import style0 from "./salesdata.vue?vue&type=style&index=0&id=b58eaf82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58eaf82",
  null
  
)

export default component.exports